import * as R from 'ramda';

import * as M from 'shared/types/models';

export function getElements({ end, start }: M.Range): number[] {
  return R.range(start, end + 1);
}
